export default __webpack_public_path__ + "static/thumb-landscape-764754ffd8eedba2fcd20a639193eb3b.png";